const priceFormat = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

/** "$1,234.50" */
export default function formatPrice(value: number): string {
  return priceFormat.format(value);
}

/** $1,234.50 as { dollars: "1,234", cents: "50" }, rounded as formatPrice rounds. */
export function getPriceParts(value: number): { dollars: string; cents: string } {
  const parts = priceFormat.formatToParts(value);
  return {
    dollars: parts
      .filter((part) => part.type === "integer" || part.type === "group")
      .map((part) => part.value)
      .join(""),
    cents: parts.find((part) => part.type === "fraction")?.value ?? "00",
  };
}
